import React, { useState, useEffect } from "react"
import { ComboBoxTemplatePure, DropDownBtnHLPure, ButtonHLPure } from "../../pures";
import { TreeView, processTreeViewItems } from '@progress/kendo-react-treeview';
import { NIL as NIL_UUID } from 'uuid';
import "./signature-request-categories.css";

const SignatureRequestCategoriesView = (props) => {
    let {
        t,
        companies,
        getCategories,
        categories,
        subCategories,
        getSubcategories,
        typeDocuments,
        selectedStep,
        step,
        stepMetadata,
        isFirstTimeCategories,
        companyIdSelected,
        categoryIdSelected,
        pathBreadcrumbSelected,
        typeDocumentSelected,
        setDigitalVaultCategory,
        onExpandTree
    } = props

    let stepData = stepMetadata[selectedStep]
    let { next: changeCategories } = stepData
    let { back: backLabel, next: nextLabel } = step

    const [select, setSelect] = useState([""]);
    const [companyId, setCompanyId] = useState(NIL_UUID)
    const [showErrorCategories, setShowErrorCategories] = useState(false)
    const [categoryId, setCategoryId] = useState(0)
    const [showErrorSub, setShowErrorSub] = useState(false)
    const [typeDocument, setTypeDocument] = useState('')
    const [showErrorComboBox, setShowComboBox] = useState(false)
    const [showErrorCompany, setShowErrorCompany] = useState(false)
    const [showErrorTypeDoc, setShowTypeDoc] = useState(false)
    const [expand, setExpand] = useState({
        ids: [],
        idField: "subcategory.id",
    });

    useEffect(() => {
        if (!isFirstTimeCategories) {
            let index = ''
            let idsExpand = []
            let pathSplit = pathBreadcrumbSelected.split("/")
            if(pathSplit && pathSplit.length === 1){
                index = subCategories.findIndex(sub => sub.subcategory.id === Number(pathBreadcrumbSelected))
            }

            if(pathSplit && pathSplit.length === 2){
                let subSplit = pathBreadcrumbSelected.split('/')
                let catId = (subSplit) ? subSplit[0] : 0
                let subId = (subSplit) ? subSplit[1] : 0
                let catIndex = subCategories.findIndex(cat => cat.subcategory.id === Number(catId))
                let catFind = subCategories[catIndex]
                let subIndex = catFind.items.findIndex(sub => sub.subcategory.id === Number(subId))
                index = `${catIndex}_${subIndex}`            
            }

            if(pathSplit && pathSplit.length === 3){
                let subSplit = pathBreadcrumbSelected.split('/')
                let catId = (subSplit) ? subSplit[0] : 0
                let subId = (subSplit) ? subSplit[1] : 0
                let subSubId = (subSplit) ? subSplit[2] : 0
                let catIndex = subCategories.findIndex(cat => cat.subcategory.id === Number(catId))
                let catFind = subCategories[catIndex]
                let subIndex = catFind.items.findIndex(sub => sub.subcategory.id === Number(subId))
                let subCat = catFind.items[subIndex]
                let subSubIndex = subCat.items.findIndex(sub => sub.subcategory.id === Number(subSubId))

                index = `${catIndex}_${subIndex}_${subSubIndex}`            
            }

            pathSplit.map(indexPath => idsExpand.push(Number(indexPath)))
            index = (index !== -1) ? index : ''

            setSelect([`${index}`])
            setCompanyId(companyIdSelected)
            setCategoryId(categoryIdSelected)
            setTypeDocument(typeDocumentSelected)
            setExpand(prev => ({
                ids: [...new Set([...prev.ids, ...idsExpand])],
                idField: "subcategory.id"
            }))
        } else {
            setDigitalVaultCategory(setCompanyId, setTypeDocument, setCategoryId, setSelect, setExpand)
            
        }
    }, [])

    const handleChange = (e, setValue, type, setShowError, typeSelect) => {
        let value = e.target.value
        if (type === 'Number') value = Number(value)
        if (setShowError) setShowError(false)
        setValue(value)

        if (typeSelect === 'company') {
            getCategories(value, setCategoryId, setSelect)
        }

        if (typeSelect === 'category') {
            getSubcategories(companyId, value, setSelect)
        }

    }

    const onItemClick = (event) => {
        setSelect([event.itemHierarchicalIndex]);
        setShowErrorSub(false)
    };

    const handleChangeCategories = (changePage) => {
        let pathBreadcrumb = ''
        let subCategoryId = 0
        if (companyId && companyId !== NIL_UUID && categoryId && categoryId > 0 && select[0] && select[0] !== '') {
            let subSplit = select[0].split('_')

            if(subSplit && subSplit.length === 1){
                let subcategory = subCategories[select[0]]
                subCategoryId = subcategory.subcategory.id
                pathBreadcrumb = `${subcategory.subcategory.id}`
            }

            if(subSplit && subSplit.length === 2){
                let catIndex = (subSplit) ? subSplit[0] : 0
                let subIndex = (subSplit) ? subSplit[1] : 1
                let catFind = subCategories[catIndex]
                let subcategoryFind = catFind.items[subIndex]
                subCategoryId = subcategoryFind.subcategory.id
                pathBreadcrumb = `${catFind.subcategory.id}/${subCategoryId}`
            }

            if(subSplit && subSplit.length === 3){
                let catIndex = (subSplit) ? subSplit[0] : 0
                let subIndex = (subSplit) ? subSplit[1] : 0
                let subSubIndex = (subSplit) ? subSplit[2] : 0
                let catFind = subCategories[catIndex]
                let subcategoryFind = catFind.items[subIndex]
                let subSubFind = subcategoryFind.items[subSubIndex]
                subCategoryId = subSubFind.subcategory.id
                pathBreadcrumb = `${catFind.subcategory.id}/${subcategoryFind.subcategory.id}/${subCategoryId}`
            }
        }

        let data = {
            companyIdSelected: companyId,
            categoryIdSelected: categoryId,
            subCategoryIdSelected: subCategoryId,
            pathBreadcrumbSelected: pathBreadcrumb,
            typeDocumentSelected: typeDocument
        }

        changeCategories(data, changePage)
    }

    const onTreeExpandChange = (event) => {
        let ids = expand.ids.slice();
        const index = ids.indexOf(event.item.subcategory.id);
        index === -1 ? ids.push(event.item.subcategory.id) : ids.splice(index, 1);
        setExpand({
            ids,
            idField: "subcategory.id",
        });
    };

    const onChangeTree = (event) => {
        setSelect([event.itemHierarchicalIndex]);
    }

    return (
        <div className="signatureRequestCategoriesView-container">
            <div className="signatureRequestCategoriesView-elements">
                <div className="signatureRequestCategoriesView-inputs">
                    <div className="signatureRequestCategoriesView-subtitle">
                        <p className="signatureRequestCategoriesView-label-title">{t("signatureRequestProfile.digitalVault.assignCategory")}</p>
                    </div>
                    <div>
                        <DropDownBtnHLPure
                            labelDropDown={t("questionnairesAssignCategories.company")}
                            optionsDropDown={companies}
                            optionsValue={companyId}
                            valueItem={"id"}
                            nameOption={"companyName"}
                            onDropDownChange={(e) => handleChange(e, setCompanyId, null, setShowErrorCompany, 'company')}
                            required
                        />
                        {
                            showErrorCompany &&
                            <p className='hint-message-error'>{`${t("questionnairesAssignCategories.company.error")}`}</p>
                        }
                    </div>
                    <div>
                        <DropDownBtnHLPure
                            labelDropDown={t("questionnairesAssignCategories.category")}
                            optionsDropDown={categories}
                            optionsValue={categoryId}
                            valueItem={"id"}
                            nameOption={"name"}
                            onDropDownChange={(e) => handleChange(e, setCategoryId, 'Number', setShowErrorCategories, 'category')}
                            required
                        />
                        {
                            showErrorCategories &&
                            <p className='hint-message-error'>{`${t("questionnairesAssignCategories.category.error")}`}</p>
                        }
                    </div>

                    <div className="signatureRequestCategoriesView-subcategory">
                        <p className="questionnairesAssignCategories-inputHLPure-label">{`${t("questionnairesAssignCategories.subcategory")}`}</p>
                        {!subCategories || subCategories.length === 0 || !subCategories[0].subcategory || !subCategories[0].subcategory.id
                            ? <p className='questionnairesAssignCategories-not-assigned'>{`${t("questionnairesAssignCategories.no.assign")}`}</p>
                            : <TreeView
                                data={processTreeViewItems(subCategories, {
                                    select: select,
                                    expand: expand,
                                })}
                                expandIcons
                                size={"medium"}
                                textField='subcategory.name'
                                onExpandChange={onTreeExpandChange}
                                onItemClick={(e) => onChangeTree(e)}
                            />
                        }
                        {
                            showErrorSub &&
                            <p className='hint-message-error'>{`t("questionnairesAssignCategories.subcategory.error)`}</p>
                        }

                    </div>
                    <div className="signatureRequestCategoriesView-type-document">
                        <ComboBoxTemplatePure
                            title={t("questionnairesAssignCategories.type.document")}
                            placeholder={t("questionnairesAssignCategories.select.type.document")}
                            allowCustom
                            data={typeDocuments}
                            textField="name"
                            dataItemKey="id"
                            value={typeDocument}
                            onChange={(e) => handleChange(e, setTypeDocument, null, setShowTypeDoc)}
                            required
                            validityStyles={false}
                            errorCombobox={showErrorComboBox}
                            errorMessage={t("questionnairesAssignCategories.error.type.document")}
                        />
                        {
                            showErrorTypeDoc &&
                            <p className='hint-message-error'>{t("questionnairesAssignCategories.error.type.document")}</p>
                        }
                    </div>
                </div>
                <div className="signatureRequestCategoriesView-btns">
                    <div className="signatureRequestCategoriesView-btn-back">
                        <ButtonHLPure
                            nameBtn={backLabel}
                            primary={false}
                            onClickBtn={() => handleChangeCategories(1)}
                        />
                    </div>

                    <ButtonHLPure
                        nameBtn={nextLabel}
                        primary={true}
                        onClickBtn={() => handleChangeCategories(2)}
                    />
                </div>
            </div>
        </div>
    )
}

export { SignatureRequestCategoriesView as default }